import type { OnboardingSchema } from '@/features/onboarding';

import { buildSelector } from '@/shared/lib/store';

// Hook selectors using buildSelector - following app standard pattern
export const [useCurrentStepIndex] = buildSelector(
    (state) => state.onboarding?.currentStepIndex ?? 0,
);

export const [useUsername] = buildSelector(
    (state) => state.onboarding?.username ?? '',
);

export const [usePhone] = buildSelector(
    (state) => state.onboarding?.phone ?? '',
);

export const [useTradingLevel] = buildSelector(
    (state) => state.onboarding?.trading_level ?? '',
);

export const [useSelectedFeatures] = buildSelector(
    (state) => state.onboarding?.selectedFeatures ?? [],
);

export const [useInterval] = buildSelector(
    (state) => state.onboarding?.interval ?? 'month',
);

export const [useIsProcessing] = buildSelector(
    (state) => state.onboarding?.isProcessing ?? false,
);

export const [useOnboardingData] = buildSelector(
    (state): OnboardingSchema | undefined => {
        const { onboarding } = state;

        return onboarding;
    },
);
